/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MinuteMove = {
    properties: {
        previousMinute: {
            type: 'number',
            isRequired: true,
        },
        actualMinute: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
